/**
 * Interval for polling company match upload status
 */
export const COMPANY_MATCH_STATUS_QUERY_INTERVAL_IN_MS = 1000 * 5; //5s

/**
 * URL for the column header specification image
 */
export const COLUMN_HEADER_IMAGE_URL =
  "https://static.hginsights.com/platform/company_match_column_spec_v3_wo_duns.png";

/**
 * Component text content
 */
export const TEXT = {
  CUSTOMER_LIST_TITLE: "Customer List for Market Analysis",
  CUSTOMER_LIST_DESCRIPTION:
    "Upload a list of customers to help identify whitespace opportunities in the market.",
  ACCOUNT_LIST_TITLE: "Account List",
  ACCOUNT_LIST_DESCRIPTION:
    "For whitespace analysis, please use the Whitespace Definition section in the configuration wizard and the Opportunity Type filter.",
  UPLOAD_TITLE: "Upload your CSV file",
  UPLOAD_POPOVER_INSTRUCTIONS: `
    <strong>HG Company ID</strong>
    <br />
    This is the HG-supplied identifier for a company. This field has the highest priority when matching against a company.
    <br />
    <br />
    <strong>DUNS</strong>
    <br />
    DUNS identifiers have the second-highest priority when matching against a company.
    <br />
    <br />
    <strong>Company Name</strong>
    <br />
    Company names will be matched against all known names associated with a company.
    <br />
    <br />
    <strong>Country</strong>
    <br />
    If provided, this will be used alongside the URL and/or company name to identify a company within a specific region.
    <br />
    <br />
    <strong>CRM ID</strong>
    <br />
    This is your CRM identifier, such as a Salesforce ID. It will not be used for matching but will be included in your output.
  `,
  UPLOAD_INSTRUCTIONS: `Upload your customer list to perform whitespace analysis. Accepted formats: CSV (UTF-8 encoding required). Choose a file or drag it here to upload.`,
  UPLOAD_BUTTON_TEXT: "Upload File",
  UPLOADING_TEXT: "Uploading...",
  ERROR_CSV_VALIDATION: "CSV validation failed",
  COLUMN_HEADERS_ALT: "column-headers",
  UNKNOWN_ERROR: "Unknown error",
  TRY_AGAIN_BUTTON: "Try Again",

  PROCESSING_STATE: {
    ALERT_TITLE: "Configuring Whitespace",
    ALERT_DESCRIPTION:
      "We're processing your uploaded data. This process might take a few moments to complete. Feel free to continue customizing your project or navigate through other platform features—you'll receive a notification when your whitespace configuration is ready.",
    PROCESSING_TEXT: "Processing...",
    UPLOAD_ACCOUNT: {
      ALERT_TITLE: "Configuring...",
      ALERT_DESCRIPTION:
        "We're processing your uploaded data. This process might take a few moments to complete. Feel free to apply the filters or navigate through other platform features—once upload is complete, you'll receive a notification.",
    },
  },
  SUCCESS_STATE: {
    ALT_MATCH_STATS_IMAGE: "Match Stats",
    ALT_FILE_INFO_IMAGE: "File Info",
    LABEL_MATCHES: "Matches",
    LABEL_NO_MATCH_FOUND: "No match found",
    LABEL_INVALID_INPUTS: "Invalid Inputs",
    LABEL_SALES_WON: "Sales Won",
    LABEL_SALES_LOST: "Sales Lost",
    LABEL_FILE_NAME: "File Name",
    LABEL_UPLOADED: "Uploaded",
    LABEL_LAST_MATCHED: "Last Matched",
  },
};

/**
 * Component file settings
 */
export const FILE_SETTINGS = {
  ACCEPTED_TYPES: ["text/csv"],
  ACCEPTED_EXTENSIONS: [".csv"],
};

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB limit
